import { Accordion } from "@mantine/core";

/**
 * Accordion component extension following Mapka UI Kit Design
 * https://www.figma.com/design/SGgCOChfc92PZwp5EqMEN0/MAPKA-UI-Kit?node-id=1049-2757&m=dev
 *
 * Variants:
 * - default: Bottom border style
 * - contained: Bottom border with container styling
 * - separated: Gray background with bottom border
 * - filled: No border, minimal style
 *
 * Chevron positions: left, right (default)
 */
export const AccordionOverwrite = Accordion.extend({
  classNames: {
    root: "mapka-accordion",
    item: "mapka-accordion-item",
    control: "mapka-accordion-control",
    label: "mapka-accordion-label",
    chevron: "mapka-accordion-chevron",
    panel: "mapka-accordion-panel",
    content: "mapka-accordion-content",
  },
});
